import { ValidationError, FetchFailedError, ErrorCode } from './apiError';
import { isLeft } from 'fp-ts/lib/Either';
import { RawApi } from '.';
import { summaryApiResponse } from './validators/score';
import { Summary, SportSummaryType } from '@/components/Sport/types';
import { convertSportSummary } from './converters/score';

export interface ScoreAPI {
  fetchScoreSummary: (
    sport: SportSummaryType,
    id: string,
    matchtype?: string | undefined,
  ) => Promise<Summary>;
}

export class ScoreApi extends RawApi implements ScoreAPI {
  public async fetchScoreSummary(
    sport: SportSummaryType,
    id: string,
    matchtype?: string | undefined,
  ): Promise<Summary> {
    const legacyApiSports = ['rugby', 'motorsport'];
    const apiVersion = legacyApiSports.includes(sport) ? 'v4' : 'v5';

    let url = `/${sport}/${apiVersion}/score/${id}/summary`;

    if (sport === 'golf') {
      if (matchtype == null || matchtype.includes('stroke')) {
        url = url.replace('/score/', `/stroke/`);
      } else {
        url = url.replace('/score/', `/matchplay/`);
      }
    }
    const response = await this.fetchScoresApi(url);

    if (!response.ok) {
      throw new FetchFailedError(
        response.statusText,
        response.status as ErrorCode,
        response,
      );
    }

    const jsonResponse: unknown = await response.json();
    const sportSummary = summaryApiResponse.decode(jsonResponse);

    if (isLeft(sportSummary)) {
      throw new ValidationError(
        'API Response validation failed',
        400,
        sportSummary,
      );
    }

    return convertSportSummary(sport, sportSummary.right);
  }
}
